module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-mobilitaetsmanagement-7440c2fcaa560be862550510d22e720d.svg";